package br.com.texeratx.boardgametimeapp.ui.screens.matches.edit

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import br.com.texeratx.boardgametimeapp.ui.screens.matches.model.MatchListItemUI
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class MatchEditScreen(
    private val match: MatchListItemUI,
    private val onMatchUpdated: (MatchListItemUI) -> Unit
) : Screen {

    @Composable
    override fun Content() {

        val navigator = LocalNavigator.currentOrThrow
        val viewModel = koinInject<MatchEditViewModel>()
        val state by viewModel.state.collectAsState()

        // Inicializa apenas uma vez
        LaunchedEffect(Unit) {
            viewModel.init(match)
        }

        state?.let { uiState ->
            MatchEditUI(
                state = uiState,

                onBack = {
                    navigator.pop()
                },

                onSave = {
                    viewModel.save { updatedMatch ->
                        // 🔁 atualiza a tela de detalhe sem refetch
                        onMatchUpdated(updatedMatch)
                        navigator.pop()
                    }
                },

                // ---------- PARTIDA ----------
                onDateChange = viewModel::updateDate,
                onTimeChange = viewModel::updateTime,
                onDurationChange = viewModel::updateDuration,
                onObservationChange = viewModel::updateObservation,

                // ---------- PLAYERS ----------
                onScoreChange = viewModel::updatePlayerScore,
                onRemovePlayer = viewModel::removePlayer,

                onAddPlayerClick = viewModel::openAddPlayerDialog,
                onAddPlayer = viewModel::addPlayer,
                onCloseAddPlayerDialog = viewModel::closeAddPlayerDialog,

                // ---------- EXPANSÕES ----------
                onToggleExpansion = viewModel::toggleExpansion
            )
        }
    }
}
